export const ADMIN_ADDRESS = "BdY1ZfXPGStwh9aWfjrwSpwahVHEsCZf6kAihkxA52oa";
export const PROJECT_VAULT_ADDRESS = "2xRvT39CaA4zWQdztj9SGpQCFqLRqHekjaPBsCKd8niW";
export const SOL = "solana";
export const USDC = "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v";
export const SKR_TOKEN_MINT = "SKRbvo6Gf7GondiT3BbTfuRDPqLWei4j2Qy2NPGZhW3";
export const SKR_PRICE_RAW = "1000000";
export const SKR_MIN_PRICE_RAW = "1000000";
export const SKR_BURN_ADDRESS = "1nc1nerator11111111111111111111111111111111";
export const PROD_AUTH_PROVIDER = "phantom_app";
export const PHANTOM_APP_ID = "7034c411-c74a-40d6-be0b-924e3f10375f";